import { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/user-context/user-context";
import { API_ENDPOINT } from "../configurations/global.config";
import axios from "axios";
import { QuickFilterScope } from "../enums/quick-filters";
import { useSnackBar } from "../contexts/snackbar";
import { IQuickFilter } from "../interfaces/common/quick-filters";

export const useQuickFilters = ({autoFetch = true}: {autoFetch?: boolean} = {}) => {
  const { config, user } = useContext(AuthContext);
  const [quickFilters, setQuickFilters] = useState<IQuickFilter[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { showMessage } = useSnackBar();
  

  const fetchQuickFilters = useCallback(
    async () => {
      if (!user) return;
      try {
        setIsLoading(true);
        const response = await axios.get<IQuickFilter[]>(
          `${API_ENDPOINT}/v1/quick-filters/`,
          config
        );
        console.log('response = ', response.data);
        setQuickFilters(response.data);
      } catch (error) {
        console.error("Failed to fetch quick filters", error);
        showMessage("Failed to fetch quick filters", "error");
      } finally {
        setIsLoading(false);
      }
    },
    [config, showMessage]
  );

  useEffect(() => {
    if (autoFetch && user) {
      fetchQuickFilters();
    }
  }, [autoFetch, user]);


  

  const createQuickFilter = useCallback(
    async (quickFilter: IQuickFilter) => {
      let filter : IQuickFilter | null = null;
      try {
        setIsLoading(true);
        const response = await axios.post(`${API_ENDPOINT}/v1/quick-filters/`, quickFilter, config);
        filter = response.data;
        setQuickFilters(prev => [...prev, filter!]);
      } catch (error) {
        console.error("Failed to create quick filter", error);
        showMessage("Failed to create quick filter", "error");
        return null;
      }
      finally {
        setIsLoading(false);
      }
      return filter;
    },
    [config]
  );

  const deleteQuickFilter = useCallback(
    async (id: string) => {
      try {
        setIsLoading(true);
        await axios.delete(
          `${API_ENDPOINT}/v1/quick-filters/${id}/`,
          config
        );
        setQuickFilters(prev =>
          prev.filter(filter => filter.id !== id)
        );
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Failed to delete quick filter", error);
        throw error;
      }
    },
    [config, showMessage]
  );

  return {
    quickFilters,
    fetchQuickFilters,
    deleteQuickFilter,
    isLoading,
    createQuickFilter
  };
};

export default useQuickFilters;
